import React, { useEffect, useState } from 'react';
import api from '../services/api';
import '../styles/AssignUsersModal.css';

export default function AssignUsersModal({ projectId, onClose }) {
    const [users, setUsers] = useState([]);
    const [assignedUsers, setAssignedUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');

    useEffect(() => {
        api.get('/User').then(res => setUsers(res.data));
        api.get(`/Project/${projectId}/users`).then(res => setAssignedUsers(res.data));
    }, [projectId]);

    const assignUser = () => {
        if (!selectedUserId) return;

        api.post('/Project/UserProject', {
            project_id: projectId,
            user_id: selectedUserId
        }).then(() => {
            const user = users.find(u => u.id === selectedUserId);
            setAssignedUsers(prev => [...prev, user]);
            setSelectedUserId('');
        });
    };

    const removeUser = (userId) => {
        api.delete('/Project/UserProject', {
            data: {
                project_id: projectId,
                user_id: userId
            }
        }).then(() => {
            setAssignedUsers(prev => prev.filter(u => u.id !== userId));
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>Benutzer zuweisen</h3>

                <select
                    value={selectedUserId}
                    onChange={e => setSelectedUserId(e.target.value)}
                    className="input"
                >
                    <option value="">User auswählen</option>
                    {users.map(u => (
                        <option key={u.id} value={u.id}>{u.username}</option>
                    ))}
                </select>
                <br></br>
                <button onClick={assignUser} className="button button-primary">
                    ➕ Zuweisen
                </button>

                <h4 style={{ marginTop: '20px' }}>Zugewiesene Benutzer:</h4>
                <ul className="user-list">
                    {assignedUsers.map(u => (
                        <li key={u.id}>
                            <span>{u.username}</span>
                            <button
                                className="button button-danger"
                                onClick={() => removeUser(u.id)}
                            >
                                ❌
                            </button>
                        </li>
                    ))}
                </ul>

                <button className="button button-close" onClick={onClose}>Schließen</button>
            </div>
        </div>
    );
}
